import React from 'react'
import { useState } from 'react';
import { createContext } from "react";

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
    const [getValueString, setGetValueString] = useState()
    const [getdDeleteTableRows, setGetDeleteTableRows] = useState()
    const [fetchBrand, setFetchBrand] = useState()
    const [itemVariations, setItemVariations] = useState();
    const [mailingAdd, setMailingAdd] = useState({
        mail: ""
    });
    const [autoGeneration, setAutoGeneration] = useState();

    const valueStringFunction = (event) => {
        console.log(getValueString)
        setGetValueString({ ...getValueString, event })
    }

    const deleteTableRowsFunction = (event) => {
        console.log(getValueString)
        setGetDeleteTableRows({ ...getdDeleteTableRows, event })
    }

    const fetchBrandFunction = (event) => {
        console.log(getValueString)
        setFetchBrand({ ...fetchBrand, event })
    }

    const fetchItemVariation = (event) => {
        console.log(getValueString)
        setItemVariations({ ...itemVariations, event })
    }

    const updateMail = (mail) => {
        console.log(mailingAdd, "fffffffffffffffffff")
        setMailingAdd({mail})
    }

    const autoGenerationFunction = (event) => {
        console.log(mailingAdd, "fffffffffffffffffff")
        setAutoGeneration({...autoGeneration, event});
    }




    return (
        <AppContext.Provider value={{ 
            valueStringFunction,
            deleteTableRowsFunction,
            fetchBrandFunction,
            fetchItemVariation,
            updateMail,
            autoGenerationFunction
         }} >{children}</AppContext.Provider>
    )
}

export default AppContextProvider